import * as Neb from "nebulas" ;
import * as NebPay from 'nebpay';

const contractAddress = 'n1eyERuA5XTYzzb82Km9NxkCu6s9LdbGpkP';

// Contract addresses

// MAINNET
// ALPHA_v0.1 - n1eyERuA5XTYzzb82Km9NxkCu6s9LdbGpkP

const nebPay = new NebPay();
const neb = new Neb.Neb();
const api = neb.api;

// Endpoints
// Mainnet: https://mainnet.nebulas.io
// Testnet: https://testnet.nebulas.io
// Local: http://localhost:8685

neb.setRequest(new Neb.HttpRequest("https://mainnet.nebulas.io"));

export { contractAddress, neb, nebPay, api };


// WEBPACK FOOTER //
// ./src/util/nebulas.js